import { IApplicationState } from '../../types/redux';

export const selectModalMode = (state: IApplicationState) => {
  return state.listingModal.mode;
};
